import apinode from '../../apinode'
import removeNonCharacters from '../../../utils/removeNonCharacters'

class FuncionariosService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll() {
    const response = await apinode.get(`/funcionarios/${this.idconta}`)

    return response.data
  }

  async getById(id) {
    const response = await apinode.get(`/funcionarios/${this.idconta}/${id}`)

    return response.data
  }

  async create(data) {
    const dataFormatted = {
      ...data,
      rg: removeNonCharacters(data.rg),
      cpf: removeNonCharacters(data.cpf),
      cep: removeNonCharacters(data.cep),
      fonefixo: removeNonCharacters(data.fonefixo),
      fonecelular: removeNonCharacters(data.fonecelular),
    }

    await apinode.post(`/funcionarios/${this.idconta}`, {
      ...dataFormatted,
    })
  }

  async update(id, data) {
    const dataFormatted = {
      ...data,
      rg: removeNonCharacters(data.rg),
      cpf: removeNonCharacters(data.cpf),
      cep: removeNonCharacters(data.cep),
      foneFixo: removeNonCharacters(data.foneFixo),
      celular: removeNonCharacters(data.fonecelular),
    }

    await apinode.put(`/funcionarios/${this.idconta}/${id}`, {
      ...dataFormatted,
    })
  }

  async resetPassword(id) {
    await apinode.patch(`/funcionarios/${this.idconta}/${id}`)
  }

  async delete(id) {
    await apinode.delete(`/funcionarios/${this.idconta}/${id}`)
  }
}

export default new FuncionariosService()
